export default [
  {
    Companies: [
      {
        fileName: "login/companii/cadou_noiembrie_2023_login.png",
        link:"https://upromania.ro/companii/card-cadou/",
        category: "Banner",
        action: "Click",
        label: "Companii_cadou_noiembrie2023",
      },
      {
        fileName: "login/companii/Cultura_oct_2023.png",
        link:
            "https://upromania.ro/companii/card-cultural/",
        category: "Banner",
        action: "Click",
        label: "Companii_cultura_VN210",
      },
      {
        fileName: "login/companii/Creste-Valoarea-nominala-uponline-1242x782.png",
        link:
          "https://upromania.ro/fisiere/ordonanta-de-urgenta-nr-69-2023-pentru-modificarea-art-14-din-legea-nr-165-2018-privind-acordarea-biletelor-de-valoare-precum-si-pentru-stabilirea-unor-masuri-pentru-aplicarea-acestor-prevederi.pdf",
        category: "Banner",
        action: "Click",
        label: "Companii_VN35",
      },
      {
        fileName: "login/companii/Up_dejun.jpg",
        link: "https://eur03.safelinks.protection.outlook.com/?url=https%3A%2F%2Fupromania.ro%2Fcompanii%2Fcard-de-masa%2F&data=05%7C01%7Cvpopa%40upromania.ro%7C8425de7d93d24c630b2408dac97f6eee%7C475fd1d1212f472f9c02635526f47568%7C0%7C0%7C638043846413138670%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=FAJbDBAoNBuAJKv%2BCUkfxNchxv0oS6opGlG%2FjsKcbJY%3D&reserved=0",
        category: "Banner",
        action: "Click",
        label: "Up_dejun_campanie",
      },
      {
        fileName: "login/companii/banner-TazzTME.jpg",
        link: "https://companie.upromania.ro/media/ultimele-noutati/up-permite-plata-tazz/",
        category: "Banner",
        action: "Click",
        label: "Companii_TazzTME",
      },

      {

        fileName: "login/companii/banner_gpay.png",
        link: "https://upromania.ro/utilizatori/google-pay/",
        category: "Banner",
        action: "Click",
        label: "Companii_GPay",
      },
      {
        fileName: "login/companii/Banner_R&C.png",
        link:
          "https://upromania.ro/recomanda/?utm_source=uponline&utm_medium=banner&utm_campaign=Recomanda",
        category: "Banner",
        action: "Click",
        label: "Companii_Recomanda&Castiga",
      },
      {
        fileName: "login/companii/banner_pay.png",
        link: "https://upromania.ro/utilizatori/up-mobil-pay/",
        category: "Banner",
        action: "Click",
        label: "Companii_UpMobilPay",
      },
      {
        fileName: "login/companii/clientVV.png",
        link: "https://catalogulcuvacante.ro/b2c/#/up/catalogs",
        category: "Banner",
        action: "Click",
        label: "Companii_ConfigVacante",
      },
      {
        fileName: "login/companii/clienti-applepay.jpg",
        link: "https://upromania.ro/utilizatori/apple-pay/",
        category: "Banner",
        action: "Click",
        label: "Companii_ApplePay",
      },
      {
        fileName: "login/companii/clienti7.png",
        link:
          "https://upromania.ro/de-la-hartie-la-card-cu-0-costuri/?utm_source=uponline&amp;utm_medium=banner&amp;utm_campaign=MigrareCardCost0",
        category: "Banner",
        action: "Click",
        label: "Companii_MigrareCard",
      },
    ],
    Beneficiaries: [
      {
        fileName: "login/utilizatori/Cultura_oct_2023.png",
        link:
            "https://upromania.ro/companii/card-cultural/",
        category: "Banner",
        action: "Click",
        label: "Companii_cultura_VN210",
      },
      {
        fileName: "login/companii/Up_dejun.jpg",
        link: "https://eur03.safelinks.protection.outlook.com/?url=https%3A%2F%2Fupromania.ro%2Fcompanii%2Fcard-de-masa%2F&data=05%7C01%7Cvpopa%40upromania.ro%7C8425de7d93d24c630b2408dac97f6eee%7C475fd1d1212f472f9c02635526f47568%7C0%7C0%7C638043846413138670%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=FAJbDBAoNBuAJKv%2BCUkfxNchxv0oS6opGlG%2FjsKcbJY%3D&reserved=0",
        category: "Banner",
        action: "Click",
        label: "Up_dejun_campanie",
      },
      {
        fileName: "login/utilizatori/banner-TazzTME.jpg",
        link: "https://companie.upromania.ro/media/ultimele-noutati/up-permite-plata-tazz/",
        category: "Banner",
        action: "Click",
        label: "beneficiari_TazzTME",
      },
      {
        fileName: "login/utilizatori/banner_upon_1242x782_nou.jpg",
        link: "https://onelink.to/88wxz5",
        category: "Banner",
        action: "Click",
        label: "UtilizatoriBonApp",
      },
      {
        fileName: "login/utilizatori/Banner RC.png",
        link: "https://upromania.ro/recomanda/",
        category: "Banner",
        action: "Click",
        label: "UtilizatoriRecomandaCastiga",
      },
      {
        fileName: "login/utilizatori/banner-McXup.jpg",
        link: "https://youtu.be/_2jTX-YoPmY",
        category: "Banner",
        action: "Click",
        label: "UtilizatoriMastercard",
      },
      {
        fileName: "login/companii/banner_pay.png",
        link: "https://upromania.ro/utilizatori/up-mobil-pay/",
        category: "Banner",
        action: "Click",
        label: "UtilizatoriCard_UpMobilPay",
      },
      {
        fileName: "login/utilizatori/clienti-applepay.jpg",
        link: "https://upromania.ro/utilizatori/apple-pay/",
        category: "Banner",
        action: "Click",
        label: "UtilizatoriCard_ApplePay",
      },
      {
        fileName: "login/utilizatori/utilizatori.png",
        link: "https://upromania.ro/utilizatori/aplicatie-card-up-romania/",
        category: "Banner",
        action: "Click",
        label: "UtilizatoriCard_UpMobile",
      },
    ],
  },
];
